import expense_tracker from "../Assests/expense_tracker.png";
import weather from "../Assests/weather_app.png";
import crypto_coders from "../Assests/crypto_coders.png";
import supply_chain from "../Assests/supply_chain.png";
import D_Shop from "../Assests/D_Shop.png";
import Keeper_app from "../Assests/keeper_app.png";
const ProjectDetails = [
  {
    title: "D-Shop",
    content:"A Complete Ecommerce Application where user can choose the products and add them to cart and pay using RazorPay payment gateway.And also it send message to user to update the order status.And it performs CURD operations from both client and admin side.And it is build on HTML,CSS,JS,REACT,NODEJS,MONGODB,FIREBASE",
    gitHub: "https://github.com/Dhanush-2605/D-Shop_Final ",
    image: D_Shop,
    liveWebsite: "#",
  },
  {
    title: "CryptoCoders",
    content: "It is a simple Decentralized application in which if a user enter name it stores in blockchain and with that name and using avatar.dicebar API it create unique avatar for each name.And it is build on REACT,SOLIDITY,TRUFFLE,GANACHE",
    gitHub: "https://github.com/Dhanush-2605/CryptoCoders_DAPP",
    image:crypto_coders,
    liveWebsite: "#",
  },
  
  {
    title: "SupplyChain Dapp",
    content: "It is a  Decentralized applicatioapplication in which members in that network add and buy products. Developed stats page in which all members in that network get to know about how much revenue generated from aparticular product is build on REACT,SOLIDITY,TRUFFLE,GANACHE",
    gitHub: "https://github.com/Dhanush-2605/supplychain_DAPP",
    image:supply_chain,
    liveWebsite: "#",
  },
  {
    title: "Keeper App",
    content: "A website in which user can add their tasks and delete them if they complete. All the tasks are stored in database it is build on HTML,CSS,JS,REACT,NODEJS,MONGODB",
    gitHub: "https://github.com/Dhanush-2605/Keeper_App",
    image:Keeper_app,
    liveWebsite: "#",
  },

  {
    title: "Expense-tracker",
    content:
      "it's a simple expense Tracker which tracks our monthly expenses build on REACT",
    gitHub: "https://github.com/Dhanush-2605/Expense-tracker ",
    image: expense_tracker,
    liveWebsite: "https://expense-tracker-81f25.web.app/",
  },
  {
    title: "Weather Application",
    content:
      "it gives weather for the particular city it uses open weather API and build on HTML,CSS,JS",
    image: weather,
    gitHub: "https://github.com/Dhanush-2605/weather--application",
    liveWebsite: "https://obscure-oasis-56493.herokuapp.com/",
  },

];

export default ProjectDetails;
